export enum RequestTypeCodes {
  LEAVE_REQUEST = 1,
  PASSPORT_REQUEST = 2,
  SALARY_CERTIFICATE = 3,
  APPRAISAL_REQUEST = 4,
  SALARY_ADVANCE = 5,
  TRAINING_REQUEST = 6,
  RESUMPTION_REQUEST = 7, // also known as re-joining request
  FAMILY_TICKET = 8,
  WARNING_NOTICE = 9,
  LABOUR_TIMESHEET = 10,
  PERFORMANCE_APPRAISAL = 11,
  WAGES_APPROVAL = 12,
  IT_REQUISITION = 13,
  MATERIAL_CREATION = 14,
  VENDOR_APPROVAL = 15,
  PERSONAL_ITEM = 16,
  PRE_TENDER_APPROVAL = 17,
  STAFF_ATTENDANCE = 18,
  BUDGET_TRANSFER = 19,
  VARIATION_ORDER = 20,
  RESOURCE_CREATION = 21,
  REQUISITION = 22,
  TELECOM_BILLING = 23,
  OVERSEAS_MISSION = 24,
  PETTY_CASH = 25,
  MAN_POWER_TRANSFER = 26,
  VISA_BATCH = 27,
  CUSTOMER = 28,
  SITE_REQUEST = 29,
  DELIVERY = 30,
  PPE_REQUEST = 31,
  PAYMENT_PROPOSAL = 32,
  ATTENDANCE_REQUEST = 33,
  STATIONARY_REQUEST = 34,
  LEAVE_SALARY_REQUEST = 35,
  BUDGET_UPLIFT = 36,
  RESIGNATION_REQUEST = 37,
}

export enum RequisitionRequestTypeCodes {
  PURCHASE_REQUEST = 2,
  TENDER_REQUEST = 3,
}
